import { MatDialogConfig } from '@angular/material/dialog';

export class DialogUtils {
  public static smallDialogConfig(options: MatDialogConfig = {}): MatDialogConfig {
    const defaultConfig: MatDialogConfig = {
      minWidth: '600px',
      width: '600px',
      disableClose: true,
    };
    return Object.assign({}, defaultConfig, options);
  }

  public static mediumDialogConfig(options: MatDialogConfig = {}): MatDialogConfig {
    const defaultConfig: MatDialogConfig = {
      minWidth: '850px',
      width: '850px',
      disableClose: true,
    };
    return Object.assign({}, defaultConfig, options);
  }

  public static largeDialogConfig(options: MatDialogConfig = {}): MatDialogConfig {
    const defaultConfig: MatDialogConfig = {
      minWidth: '1200px',
      width: '1200px',
      disableClose: true,
    };
    return Object.assign({}, defaultConfig, options);
  }
}
